/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { translate } from '@openclassrooms/translations';

function setTimelineIconState(isSuccess) {
  const currentTimelineStep = document.querySelector('.js-current-timeline-step');

  if (!currentTimelineStep) {
    return;
  }

  currentTimelineStep.classList.add(`timeline__step--${isSuccess ? 'completed' : 'failed'}`);
}

function setSidebarIconState(isSuccess) {
  const tocItem = document.querySelector('.js-toc-exercise-item-selected');
  const tocIcon = document.querySelector('.js-toc-exercise-item-selected > .js-toc-icon');

  if (!tocItem) {
    return;
  }

  tocItem.classList.add(`tocExercise__item--${isSuccess ? 'passed' : 'failed'}`);

  if (tocIcon) {
    tocItem.removeChild(tocIcon);
  }

  const icon = document.createElement('span');
  [
    'roundIcon',
    'course-part-summary__exerciseCompleted',
    'col-nav__completed',
    'tocExercise__itemIcon',
    'js-tooltip',
    'js-toc-icon',
  ].forEach((className) => {
    icon.classList.add(className);
  });

  icon.setAttribute(
    'title',
    isSuccess
      ? translate('exercise.toc.exercise_passed')
      : translate('exercise.toc.exercise_failed')
  );

  icon.innerHTML = `<i class="icon-${isSuccess ? 'check2' : 'close'} roundIcon__icon"></i>`;

  tocItem.insertBefore(icon, tocItem.children[0]);
}

function setCurrentItemState(isSuccess) {
  setTimelineIconState(isSuccess);
  setSidebarIconState(isSuccess);
}

export const FAIL = false;
export const SUCCESS = true;

export default {
  setCurrentItemState,
};
